module.exports = __webpack_public_path__ + "img/logoBranco.a30645cf.png";